const actionTypes = {
  CLEAR_MESSAGES: 'CLEAR_MESSAGES',
  ANNOUNCE_POLITE_MESSAGE: 'ANNOUNCE_POLITE_MESSAGE',
  ANNOUNCE_ASSERTIVE_MESSAGE: 'ANNOUNCE_ASSERTIVE_MESSAGE',
};

const clearMessages = () => ({ type: actionTypes.CLEAR_MESSAGES });
const announcePoliteMessage = message => ({ type: actionTypes.ANNOUNCE_POLITE_MESSAGE, payload: message });
const announceAssertiveMessage = message => ({ type: actionTypes.ANNOUNCE_ASSERTIVE_MESSAGE, payload: message });

export {
  actionTypes,
  clearMessages,
  announcePoliteMessage,
  announceAssertiveMessage,
};
